import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { DATA } from "b2b/api/paths";
import { Zakaznik } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACZakaznici({ ...props }) {
  const { zakazniciLabel, zakazniciPlaceholder } = useMessages();
  return (
    <Field
      component={Inputs.AutoComplete}
      url={DATA.zakaznici()}
      rendererSelected={Zakaznik}
      rendererOption={Zakaznik}
      loadOnce
      staticKey="nazev"
      minChars={0}
      label={zakazniciLabel()}
      placeholder={zakazniciPlaceholder()}
      descriptionRenderer={Zakaznik}
      {...props}
    />
  );
}

ACZakaznici.propTypes = {
  multiple: T.bool
};

export default React.memo(ACZakaznici);
